/**
 * Campaign Onboarding - Polling for async step status
 */
(function (global) {
  "use strict";

  var CampaignOnboarding = global.CampaignOnboarding;

  function resetButton(btn, stepId, originalText) {
    btn.disabled = false;
    btn.innerHTML =
      '<i class="glyphicon glyphicon-' +
      CampaignOnboarding.getButtonIcon(stepId) +
      '"></i> ' +
      (btn.dataset.activeText ||
        btn.dataset.defaultText ||
        originalText.replace(/<[^>]*>/g, "").trim());
  }

  function pollForStatus(
    stepId,
    config,
    btn,
    resultDiv,
    successDiv,
    errorDiv,
    errorMessage,
    existingAlert,
    originalText,
  ) {
    var statusUrl = document.body.dataset.urlStatus;
    if (!statusUrl) {
      console.error("Status URL not configured");
      return;
    }

    var attempts = 0;
    var ctx = CampaignOnboarding.createContext();
    var maxAttempts = CampaignOnboarding.MAX_POLL_ATTEMPTS;
    var pollInterval = CampaignOnboarding.POLL_INTERVAL;

    function checkStatus() {
      attempts++;
      if (attempts > maxAttempts) {
        resultDiv.classList.remove("hidden");
        successDiv.classList.add("hidden");
        errorDiv.classList.remove("hidden");
        errorMessage.textContent =
          "Job timed out. Please refresh the page and check status.";
        resetButton(btn, stepId, originalText);
        return;
      }

      fetch(statusUrl, {
        method: "GET",
        headers: { Accept: "application/json" },
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (status) {
          if (status[config.completedStatus]) {
            resultDiv.classList.remove("hidden");
            successDiv.classList.remove("hidden");
            errorDiv.classList.add("hidden");
            if (existingAlert) existingAlert.classList.add("hidden");

            if (config.onAsyncComplete) {
              config.onAsyncComplete(status, ctx);
            }
            resetButton(btn, stepId, originalText);
            return;
          }

          if (status[config.failedStatus]) {
            resultDiv.classList.remove("hidden");
            successDiv.classList.add("hidden");
            errorDiv.classList.remove("hidden");
            errorMessage.textContent =
              status.latest_error || "Job failed. Please try again.";
            resetButton(btn, stepId, originalText);
            return;
          }

          if (status[config.processingStatus]) {
            btn.innerHTML =
              '<i class="glyphicon glyphicon-refresh spinning"></i> Processing...';
          }

          setTimeout(checkStatus, pollInterval);
        })
        .catch(function (error) {
          console.error("Error polling status:", error);
          setTimeout(checkStatus, pollInterval);
        });
    }

    checkStatus();
  }

  global.CampaignOnboarding = global.CampaignOnboarding || {};
  global.CampaignOnboarding.resetButton = resetButton;
  global.CampaignOnboarding.pollForStatus = pollForStatus;
})(typeof window !== "undefined" ? window : this);
